import { DOMAINS } from '../Constants'

export default function ({ singleSpa, loader }) {
  const appsToRegister = Object.keys(DOMAINS).filter((domain) => {
    const { isService } = DOMAINS[domain]
    return !isService
  })

  const singleSpaAppsConfig = appsToRegister.map((domain) => {
    const {
      name, aliasImport, path = '', unloadApp = false, auth,
    } = DOMAINS[domain]
    const dependencies = () => loader.import(aliasImport)

    const rules = (location) => {
      if (!path || location.pathname.startsWith(path)) {
        return true
      }

      if (unloadApp) {
        singleSpa.unloadApplication(name, { waitForUnmount: true })
      }
      return false
    }

    return {
      name,
      dependencies,
      rules,
      auth,
    }
  })

  return {
    singleSpaAppsConfig,
  }
}
